exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title {\r\n    font-family: \"Corbel\";\r\n    font-size: 25px;\r\n    font-weight: bold;\r\n    color: black;\r\n}\r\n\r\ndiv.apartment-three-container {\r\n    margin-top: 0;\r\n    width: 100%;\r\n    background-color: white;\r\n    margin-bottom: 20px;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.container {\r\n    max-width: 900px;\r\n    width: 100%;\r\n}\r\n\r\n.separator {\r\n    width: 100%;\r\n    margin: 25px auto 27px auto;\r\n    display: block;\r\n    height: 1px;\r\n    background: #c0c0c0;\r\n    max-width: 800px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/apartment-three/apartment-three.component.css
// module id = 748
// module chunks = 1